import { cond, overEvery, T } from 'lodash/fp';
import { Fragment } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { LocalizedDateFromUtc, SpacedDash } from '@mews-commander/ui';
import { propIsNotNull, propIsNull } from '@mews-commander/utils';

const AlwaysLabel = () => <LocalizedText textKey={TextKey.Always} />;

const FromLabel = ({ startUtc }: $TSFixMe) => (
    <Fragment>
        <LocalizedText textKey={TextKey.FromDate} />
        {UnicodeEntity.NoBreakSpace}
        <LocalizedDateFromUtc utcString={startUtc} />
    </Fragment>
);

const ToLabel = ({ endUtc }: $TSFixMe) => (
    <Fragment>
        <LocalizedText textKey={TextKey.ToDate} />
        {UnicodeEntity.NoBreakSpace}
        <LocalizedDateFromUtc utcString={endUtc} />
    </Fragment>
);

const IntervalLabel = ({ startUtc, endUtc }: $TSFixMe) => (
    <>
        <LocalizedDateFromUtc utcString={startUtc} dataTestId={DataTestId.StartDate} />
        {SpacedDash}
        <LocalizedDateFromUtc utcString={endUtc} dataTestId={DataTestId.EndDate} />
    </>
);

const DateRangeLabel = cond([
    [overEvery([propIsNull('startUtc'), propIsNull('endUtc')]), AlwaysLabel],
    [overEvery([propIsNotNull('startUtc'), propIsNull('endUtc')]), FromLabel],
    [overEvery([propIsNull('startUtc'), propIsNotNull('endUtc')]), ToLabel],
    [T, IntervalLabel],
]);

export default DateRangeLabel;
